
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnGrid extends _Ext.GridBase<POSReturnRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturn'; }
        protected getDialogType() { return POSReturnDialog; }
        protected getIdProperty() { return POSReturnRow.idProperty; }
        protected getInsertPermission() { return POSReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnRow.localTextPrefix; }
        protected getService() { return POSReturnService.baseUrl; }

        private autoSize; 
        constructor(container: JQuery, options) {
            super(container, options);

        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucher = FormatHelper.GetVoucherNo(49);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[49].AutoPosting;

            this.editItem(<POSReturnRow>{
                VoucherNo: voucher,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 49,
                AutoPosting: autoposting,
                TransDate: now.toDateString(),
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest; 



                //request.Criteria = Serenity.Criteria.and(request.Criteria, Serenity.Criteria.apply([[fld.CustomerId], '=', [POSReturnGrid.CustomerId]]));
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}